import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ExcelFileUploadProvider from "./context/ExcelFileUploadProvider";
import { BrowserRouter as Router } from "react-router-dom";
import AlertProvider from "./context/AlertProvider";
import ModalHistoryProvider from "./context/ModalHistoryProvider";
import DealsProvider from "./context/DealsProvider";
import MatchToCarProvider from "./context/MatchToCarProvider";
import SystemProvider from "./context/SystemProvider";
//import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DealsProvider>
      <ExcelFileUploadProvider>
        <ModalHistoryProvider>
          <MatchToCarProvider>
            <AlertProvider>
              <SystemProvider>
                <Router>
                  <App />
                </Router>
              </SystemProvider>
            </AlertProvider>
          </MatchToCarProvider>
        </ModalHistoryProvider>
      </ExcelFileUploadProvider>
    </DealsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
